import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

interface ContributionMappingHeadingProps {
  heading: string;
  subheading: string;
  className?: string;
}

const StyledDiv = styled.div`
  padding: ${SPACERS.small};
  border-radius: ${SPACERS.extraTiny};
  background-color: ${COLORS.grayLight};
  .contribution-mapping-heading {
    margin-bottom: 5px;
  }
  .contribution-mapping-subheading {
    max-width: 258px;
  }
`;

const ContributionMappingHeading: React.FC<ContributionMappingHeadingProps> = ({
  heading,
  subheading,
  className,
}) => {
  return (
    <StyledDiv className={className}>
      <TrueImpactText
        variant="body-large-bold"
        className="contribution-mapping-heading"
      >
        {heading}
      </TrueImpactText>
      <TrueImpactText
        variant="body-small"
        className="contribution-mapping-subheading"
      >
        {subheading}
      </TrueImpactText>
    </StyledDiv>
  );
};

export default ContributionMappingHeading;
